import React from 'react';
import { abbreviateNum } from 'lib/helpers';

export interface Slide6Props {
  allTimeStats: any;
}

/** Slide 6 - All time totals */
export const Slide06 = ({
  allTimeStats,
}: Slide6Props) => {
  // Check if any of the stats are in hundreds of millions (but less than 1 billion)
  const hasMillions = (allTimeStats.posts >= 100000000 && allTimeStats.posts < 1000000000)
                     || (allTimeStats.views >= 100000000 && allTimeStats.views < 1000000000)
                     || (allTimeStats.likes >= 100000000 && allTimeStats.likes < 1000000000);
  const numberFontSize = hasMillions ? 'text-5xl top-[22%]' : 'text-6xl md:top-[20%] top-[18%]';

  return (
    <div className="absolute inset-0 text-center h-full text-teal">
      <div className={`absolute left-0 right-10 ${numberFontSize}`}>
        <div className="flex flex-cols cols-2 pb-10 pt-36">
          <div className="text-2xl text-left border-b-2 border-teal font-semibold pl-10 self-end pb-2">
            Posts
          </div>
          <div className="font-extrabold w-full text-right animate-flyright opacity-0 [animation-fill-mode:both]">
            {abbreviateNum(allTimeStats.posts, 1)}
          </div>
        </div>
        {allTimeStats.views > 0 && (
          <div className="flex flex-cols cols-2 pb-10">
            <div className="text-2xl text-left border-b-2 border-teal font-semibold pl-10 self-end pb-2">
              Views
            </div>
            <div className="font-extrabold w-full text-right animate-flyright opacity-0 [animation-delay:200ms] [animation-fill-mode:both]">
              {abbreviateNum(allTimeStats.views, 1)}
            </div>
          </div>
        )}
        <div className="flex flex-cols cols-2">
          <div className="text-2xl text-left border-b-2 border-teal font-semibold pl-10 self-end pb-2">
            Likes
          </div>
          <div className="font-extrabold w-full text-right animate-flyright opacity-0 [animation-delay:400ms] [animation-fill-mode:both]">
            {abbreviateNum(allTimeStats.likes, 1)}
          </div>
        </div>
      </div>
    </div>
  );
};
